import React, { Component } from 'react';
import { Button, Checkbox, Col, Icon, Input, Row, Tag } from 'antd';
import './SelectApportionObj.less';
import { queryApportionOrigin } from '@api/finance/apportion';

class ModalApportion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      treeData: [],
      searchKey: '',
    };
  }

  componentDidMount() {
    this.getApportionOrigin();
  }

  componentWillMount() {}

  reset = () => {
    const { treeData } = this.state;
    const newData = treeData.map(item => {
      return {
        ...item,
        children: item.children.map(item2 => ({ ...item2, isChoosed: false })),
      };
    });
    this.setState({
      treeData: newData,
      searchKey: '',
    });
    this.props.onChange([]);
  };

  getApportionOrigin = () => {
    queryApportionOrigin().then(res => {
      if (this.props.choosedArr) {
        res.data.map(item => {
          item.children.map(item2 => {
            if (this.props.choosedArr.some(item3 => item3 === item2.value)) {
              item2.isChoosed = true;
            }
            return item2;
          });
          return item;
        });
      }
      this.setState({
        treeData: res.data,
      });
    });
  };

  onChange = () => {};

  handleOpen = key => {
    const { treeData } = this.state;
    this.loopFind(treeData, key);
    this.setState({
      treeData,
    });
  };

  // 控制子列表是否显示
  loopFind = (data, key) => {
    data.map(item => {
      if (item.value === key) {
        item.isOpen = !item.isOpen;
      }
      return item;
    });
  };

  handleChange = (key, parentId) => {
    const { treeData } = this.state;
    const newData = treeData.map(item => {
      if (item.value === parentId) {
        return {
          ...item,
          children: item.children.map(item2 => {
            if (item2.value === key) {
              return {
                ...item2,
                isChoosed: !item2.isChoosed,
              };
            }
            return {
              ...item2,
            };
          }),
        };
      }
      return item;
    });
    this.setState({
      treeData: newData,
    });
  };

  handleAllChange = record => {
    const { treeData } = this.state;
    const newData = treeData.map(item => {
      if (item.value === record.value) {
        const isTrue = item.children.every(item2 => item2.isChoosed);
        if (!isTrue) {
          return {
            ...item,
            children: item.children.map(item3 => ({
              ...item3,
              isChoosed: true,
            })),
          };
        }
        return {
          ...item,
          children: item.children.map(item3 => ({ ...item3, isChoosed: false })),
        };
      }
      return item;
    });
    this.setState({
      treeData: newData,
    });
  };

  handleSearch = e => {
    this.setState({
      searchKey: e.target.value,
    });
  };

  loopSearchFilter = (data, key) => {
    data.map(item => {
      item.isOpen = true;
      item.children = item.children.filter(it => {
        return it.title.indexOf(key) >= 0;
      });
      return item;
    });
    data = data.filter(item => {
      return item.children.length > 0;
    });
    return data;
  };

  handleAdd = () => {
    const { treeData } = this.state;
    const newDataList = treeData
      .reduce((total, curr) => {
        const data = curr.children.map(item => {
          return {
            ...item,
            type: curr.value,
          };
        });
        return total.concat(data);
      }, [])
      .filter(item2 => item2.isChoosed);
    this.props.onChange(newDataList);
  };

  renderUser = (data, parentId) => {
    const com = data.map(item => {
      if (item.children) {
        return (
          <li key={item.value} style={{ marginBottom: '5px' }}>
            <Icon
              className={item.isOpen ? 'open' : 'close'}
              type="caret-down"
              onClick={() => this.handleOpen(item.value)}
            />
            <Checkbox
              style={{ marginRight: '5px' }}
              onChange={() => this.handleAllChange(item)}
              checked={item.children.length > 0 && item.children.every(item2 => item2.isChoosed)}
            />
            {item.title}
            <ul className={item.isOpen ? 'childOpen' : 'childClose'}>
              {this.renderUser(item.children, item.value)}
            </ul>
          </li>
        );
      }
      return (
        <li key={item.value} style={{ marginLeft: '26px', marginBottom: '5px' }}>
          <Checkbox
            style={{ marginRight: '5px' }}
            onChange={() => {
              this.handleChange(item.value, parentId);
            }}
            checked={item.isChoosed}
          />
          {item.title}
        </li>
      );
    });
    return <div>{com}</div>;
  };

  renderSearchUser = (data, parentId) => {
    const { searchKey } = this.state;
    if (!searchKey) {
      return null;
    }
    const com = data.map(item => {
      if (item.children) {
        if (item.children.every(it => it.title.indexOf(searchKey) < 0)) {
          return null;
        }
        return (
          <li key={item.value} style={{ marginBottom: '5px' }}>
            <Icon
              className={item.isOpen ? 'open' : 'close'}
              type="caret-down"
              onClick={() => this.handleOpen(item.value)}
            />
            <Checkbox
              style={{ marginRight: '5px' }}
              onChange={() => this.handleAllChange(item)}
              checked={item.children.length > 0 && item.children.every(item2 => item2.isChoosed)}
            />
            {item.title}
            <ul className={item.isOpen ? 'childOpen' : 'childClose'}>
              {this.renderSearchUser(item.children, item.value)}
            </ul>
          </li>
        );
      }
      return item.title.indexOf(searchKey) >= 0 ? (
        <li key={item.value} style={{ marginLeft: '26px', marginBottom: '5px' }}>
          <Checkbox
            style={{ marginRight: '5px' }}
            onChange={() => {
              this.handleChange(item.value, parentId);
            }}
            checked={item.isChoosed}
          />
          {item.title}
        </li>
      ) : null;
    });
    return <div>{com}</div>;
  };

  render() {
    const { treeData, searchKey } = this.state;
    return (
      <Row>
        <Col span={5} className="appLabel">
          预算分摊：
        </Col>
        <Col span={14}>
          <div className="left">
            <div className="selected">
              {treeData.map(item => {
                if (item.children.length > 0 && item.children.every(item2 => item2.isChoosed)) {
                  return (
                    <Tag
                      closable
                      key={item.value}
                      onClose={() => {
                        this.handleAllChange(item);
                      }}
                    >
                      {item.title}
                    </Tag>
                  );
                }
                return item.children.map(item2 => {
                  if (item2.isChoosed) {
                    return (
                      <Tag
                        closable
                        key={item2.value}
                        onClose={() => {
                          this.handleChange(item2.value, item.value);
                        }}
                      >
                        {item2.title}
                      </Tag>
                    );
                  }
                  return null;
                });
              })}
            </div>
            <div className="wrapper">
              <div className="searchBox">
                <Input
                  style={{
                    border: 'none',
                    borderBottom: '1px solid #ddd',
                    borderRadius: '0',
                  }}
                  onPressEnter={this.handleSearch}
                  placeholder="关键字搜索"
                />
                {searchKey === '' ? (
                  <ul className="selectList">{this.renderUser(treeData)}</ul>
                ) : (
                  <ul className="selectList">{this.renderSearchUser(treeData)}</ul>
                )}
              </div>
            </div>
          </div>
        </Col>
        <Col span={4}>
          <Button
            type="primary"
            style={{ marginBottom: '8px', marginTop: '130px' }}
            onClick={this.handleAdd}
          >
            添加
          </Button>
          <Button onClick={this.reset}>重置</Button>
        </Col>
      </Row>
    );
  }
}

export default ModalApportion;



// WEBPACK FOOTER //
// ./src/components/comm/apportion/SelectShow.js